<!--合同管理-->
<template>
  <div class="contractcManage">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>历史合同</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="table-custom-box" id="auto-0">
      <el-table :data="dataList" border>
        <el-table-column
          prop="contractName"
          label="合同名称"
          width="300"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="签署状态" width="200">
          <template v-slot="scope">
            <span class="sign-status expire">{{ scope.row.signStatusDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column label="签署渠道" width="150">
          <template v-slot="scope">
            <span v-if="scope.row.signChannel == 1">线下</span>
            <span v-if="scope.row.signChannel == 0">线上</span>
          </template>
        </el-table-column>

        <el-table-column prop="secondPartyName" :show-overflow-tooltip="true" label="承运公司"></el-table-column>
        <el-table-column prop="deadline" label="过期时间" width="180">
          <template v-slot="scope">
            {{ scope.row.expireTime | stamp2TextDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template v-slot="scope">
            <el-button type="text" class="font-size12" @click="handleToView(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--短信验证-->
    <el-dialog
      :visible.sync="validPhoneTip"
      title="验证手机号"
      custom-class="tip-dialog"
      :before-close="handleCloseValidPhoneTip"
    >
      <p class="font-f90"><span class="send-tip"></span>因合同内容涉及到敏感信息，查看合同详情需验证手机号</p>
      <div class="send-box">
        <div class="send-item">
          <span class="name">手机号</span>
          <span class="dec">{{ userPhone }}</span>
        </div>
        <div class="send-item">
          <span class="name">验证码</span>
          <div class="send-code-box">
            <el-input
              placeholder="请输入验证码"
              :maxlength="6"
              type="text"
              auto-complete="off"
              v-model.trim="validCode"
            >
            </el-input>
            <el-button @click="getCode" class="code-btn" :disabled="countdown.issend">
              <span v-if="countdown.issend" class="sen-dec">{{ countdown.second }}s</span>
              <span v-else>获取验证码</span>
            </el-button>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="handleSure" :disabled="!validCode">确定</el-button>
      </div>
    </el-dialog>
    <ul id="contrat-viewer">
      <li v-for="(img, index) in viewerData" :key="index">
        <img :src="img" :alt="img.title || '图片'" style="display: none" />
      </li>
    </ul>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:0
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/settings.new.api';
import { WUYI } from '@/api/common';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
export default {
  name: 'ContractHistory',
  data() {
    return {
      dataList: [],
      heightObj: {
        height: window.innerHeight - 300 + 'px'
      },
      contractUrl: '',
      validPhoneTip: false,
      userPhone: WUYI.currentData.user.usermobile,
      validCode: '',
      contractNo: '',
      timer: null,
      countdown: {
        first: false,
        issend: false,
        second: 60
      },
      signChannel: '',
      contratViewer: '',
      viewerData: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      axios.post(api.getContractList, { queryType: 2 }).then(res => {
        this.dataList = res.data.list;
      });
    },

    handleToView(item) {
      this.signChannel = item.signChannel;
      this.contractNo = item.contractNo;
      this.validPhoneTip = true;
    },
    //倒计时
    countDown() {
      var _this = this;
      if (this.countdown.second == 0) {
        this.countdown.issend = false;
        this.countdown.second = 60;
      } else {
        this.countdown.second--;
        this.timer = setTimeout(function () {
          _this.countDown();
        }, 1000);
      }
    },
    getCode() {
      if (this.countdown.issend) return;
      axios.post(api.contractSendSms).then(res => {
        this.countdown.issend = true;
        this.countDown();
      });
    },
    handleCloseValidPhoneTip() {
      this.validPhoneTip = false;
      clearTimeout(this.timer);
      this.validCode = '';
      this.countdown.issend = false;
      this.countdown.second = 60;
    },
    handleSure() {
      axios.post(api.contractCheckSms, { authCode: this.validCode, contractNo: this.contractNo }).then(res => {
        this.handleCloseValidPhoneTip();
        if (this.signChannel == 1) {
          this.viewerData = res.data.downLoadUrl.split(',');
          this.$nextTick(() => {
            this.showViewer();
          });
        } else {
          WUYI.openNewtab(res.data.downLoadUrl);
        }
      });
    },
    showViewer() {
      const dom = document.getElementById('contrat-viewer');
      this.contratViewer = new Viewer(dom);
      this.contratViewer.show();
      dom.addEventListener('hidden', () => {
        this.contratViewer.destroy(); // 关闭时销毁实例
      });
    }
  }
};
</script>
<style scoped>
.contractcManage {
  margin-bottom: 40px;
}
.sign-status {
  display: block;
  width: 58px;
  height: 22px;
  background: #fcf5eb;
  border: 1px solid #f8e5c9;
  color: #e29f4f;
  text-align: center;
}
.sign-status.expire {
  background: #fef1f0;
  border: 1px solid #fdd7d6;
  color: #f56c6d;
}
.send-tip {
  display: inline-block;
  margin: -2px 3px 0 3px;
  width: 16px;
  height: 16px;
  background: url('../../assets/img/common/ico_fbhy_qrsj_g.png') no-repeat;
  background-size: 100%;
  vertical-align: middle;
}
.send-box {
  margin: 10px 0 0 5px;
}
.sen-dec {
  color: #58626b;
}
.send-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.send-item .name {
  width: 60px;
  color: #90a0b1;
}
.send-item .dec {
  color: #58626b;
}
.send-code-box {
  width: 288px;
  position: relative;
  overflow: hidden;
}
.send-code-box .code-btn {
  position: absolute;
  top: 1px;
  right: 2px;
  bottom: 4px;
  padding: 10px 5px;
  background: none;
  border: none;
  color: #1cc466;
  height: 30px;
  z-index: 2;
}
</style>
<style>
.contractcManage .privacy-policy-dia {
  width: 860px;
}
.contractcManage .privacy-policy-dia-content {
  margin: 0 10px;
}
.contractcManage .privacy-policy-dia .el-dialog__body {
  padding-top: 10px;
}
.contractcManage .privacy-policy-iframe {
  width: 100%;
  overflow-y: auto;
  border: none;
  margin-bottom: 10px;
}
</style>
